/**
 * the type of spirits
 */
export type SpiritType =
  | 'COGNAC'
  | 'WHISKY'
  | 'RUM'
  | 'GIN'
  | 'VODKA'
  | 'LIQUEUR'
  | 'BITTER'
  | 'FRUIT_SPIRIT'
  | 'TEQUILA'
  | 'OTHER';

export const SpiritType = {
  Cognac: 'COGNAC' as SpiritType,
  Whisky: 'WHISKY' as SpiritType,
  Rum: 'RUM' as SpiritType,
  Gin: 'GIN' as SpiritType,
  Vodka: 'VODKA' as SpiritType,
  Liqueur: 'LIQUEUR' as SpiritType,
  Bitter: 'BITTER' as SpiritType,
  FruitSpirit: 'FRUIT_SPIRIT' as SpiritType,
  Tequila: 'TEQUILA' as SpiritType,
  Other: 'OTHER' as SpiritType,
};
